import React from 'react';
import { Row } from 'react-styled-flexboxgrid';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import STEP_CONFIG from '@/view/app/Routes/StepConfig';

import { getStepHeaderSubtitle } from './StepSubtitle.helpers';
import { $StepHeaderDidactic } from './StepSubtitle.styles';

interface StepSubtitleProps {
  stepName: STEP_CONFIG;
}

const StepSubtitle: React.FC<StepSubtitleProps> = ({ stepName }) => {
  return (
    <Row start="xs">
      <$StepHeaderDidactic>
        <SafeFormattedMessageWithoutSpread
          message={getStepHeaderSubtitle(stepName)}
        />
      </$StepHeaderDidactic>
    </Row>
  );
};

StepSubtitle.displayName = 'StepSubtitle';

export default StepSubtitle;
